// extracted by mini-css-extract-plugin
export default {"customersWrapper":"CustomersCounter_customersWrapper__KQN-l","customerList":"CustomersCounter_customerList__fAbcE","customersText":"CustomersCounter_customersText__c4WNt"};